
import { Moon, Sun } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTheme } from "./ThemeProvider";
import { useTranslation } from "react-i18next";
import { useThemeCustomization } from "@/hooks/useThemeCustomization";

export function ThemeToggle({ respectGymPolicy = true }: { respectGymPolicy?: boolean }) {
  const { theme, setTheme } = useTheme();
  const { t } = useTranslation("common");
  const { canChooseTheme } = useThemeCustomization();

  if (respectGymPolicy && !canChooseTheme) return null;

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={() => setTheme(theme === "light" ? "dark" : "light")}
      aria-label={t('toggleTheme')}
    >
      <Sun className="h-5 w-5 rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
      <Moon className="absolute h-5 w-5 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
      <span className="sr-only">{t('toggleTheme')}</span>
    </Button>
  );
}
